import { Component, type ErrorInfo, type ReactNode } from 'react';

/** Keeps the client chrome up when a recut/unpublished clip throws in a page. */
export class PortalErrorBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info.componentStack);
  }

  render() {
    if (!this.state.error) {
      return <div className="flex min-h-0 flex-1 flex-col">{this.props.children}</div>;
    }
    return (
      <div className="grid flex-1 place-items-center px-6 py-16 text-center">
        <div>
          <div className="text-sm font-semibold text-white">This event is no longer available.</div>
          <p className="mt-1 max-w-sm text-xs text-subtle">
            The clip was taken down or recut. Open the library again like a first visit.
          </p>
          <button
            type="button"
            className="btn-primary mt-4"
            onClick={() => {
              this.setState({ error: null });
              window.location.assign('/clips');
            }}
          >
            Back to clips
          </button>
        </div>
      </div>
    );
  }
}
